import {get, post, put, del, postKfOrYH} from './base'
import qs from "qs";

//首页模板地址列表
export function getSoftlinksList(pageNum){
    // return get('/v3/hptemps',{pageNum})
    return get('/api/admin2/hptemps',{pageNum}) //冯修改
}
export function getSoftlinks(id){
    // return get('/v3/hptemp/' + id)
    return get('/api/admin2/hptemp/' + id) //冯修改
}
//新增首页模板地址
export function postSoftlinks(data){
    // return post('/v3/hptemp' , data)
    return post('/api/admin2/hptemp' , data) //冯修改
}
export function  putSoftlinks(id,data){
    // return put('/v3/hptemp/' +id,data)
    return put('/api/admin2/hptemp/' +id,data) //冯修改
}
//模板是否开启
export function  putSwitchOpen(id,data){
    // return put('/v3/hptempu/' +id, qs.stringify(data))
    return put('/api/admin2/hptempu/' +id, qs.stringify(data)) //冯修改
}
//删除首页模板
export function delSoftlinks(id){
    // return del('/v3/hptemp/' + id)
    return del('/api/admin2/hptemp/' + id) //冯修改
}


//首页功能类型
//获取功能类型
export function getFunctionTypes(pageNum){
    // return get('/v3/types',{pageNum})
    return get('/api/admin2/types',{pageNum}) //冯修改
}

export function getType(id){
    // return get('/v3/type/' + id)
    return get('/api/admin2/type/' + id) //冯修改
}
//新增功能类型
export function postFunctionTypes(data){
    // return post('/v3/type' , data)
    return post('/api/admin2/type' , data) //冯修改
}
//是否开启
export function putTypesOpen(id,data){
    return put('/api/admin2/typet/' +id,qs.stringify(data)) //冯修改
}
//修改
export function putFunctionTypes(id,data){
    return put('/api/admin2/type/' +id,data) //冯修改
}
//删除
export function delFunctionTypes(id){
    // return del('/v3/type/' + id)
    return del('/api/admin2/type/' + id) //冯修改
}


//首页功能管理
//获取功能列表
export  function  getFunctionList(pageNum){
    // return get('/v3/cus',{pageNum})
    return get('/api/admin2/cus',{pageNum}) //冯修改
}
export function getFunctionId(id){
    // return get('/v3/cu/' +id)
    return get('/api/admin2/cu/' +id) //冯修改
}
export function postFunction(data){
    // return post('/v3/cu',data)
    return post('/api/admin2/cu',data) //冯修改
}

export function putFunction(id,data){
    // return put('/v3/cu/' + id ,data)
    return put('/api/admin2/cu/' + id ,data) //冯修改
}
export function putFunctionOpen(id,data){
    return put('/api/admin2/cu/open/' + id, qs.stringify(data)) //冯修改
}
export function delFunction(id){
    // return del('/v3/cu/' +id)
    return del('/api/admin2/cu/' +id) //冯修改
}
export function geTypeList(){
    return get('/api/admin2/types',{'pageNum':1,'pageSize':9999}) //冯修改
}



//首页模板管理

//获取模板列表
export function getTemplates(pageNum,name){
    return get('/v3/hometemps',{pageNum,name})
}
//获取模板列表
// export function getTemplate(data){
//     return get('/v3/hometemps',data)
// }
export function getTemplate(data){
    return get('/yun/homeTemp',data)
}
export function getTemplateSon(id){
    return get('/yun/homeTempChild/'+id)
}

export function getTemplatrsId(id){
    return get('/yun/homeTemp/' + id)
}
// //新增模板
// export function postTemplates(data){
//     return post('/v3/hometemp',data)
// }
//新增首页模板
export function postTemplates(data){
    return post('/yun/homeTemp',data)
}
//新增界面功能图标
export function getTemplateIcon(){
    // return get('/v3/cus',{'pageNum':1,'pageSize':9999})
    return get('/api/admin2/cus',{'pageNum':1,'pageSize':9999}) //冯修改
}
//新增界面选择模板
// export function getTemplateTitle(){
//     return get('/v3/hptemps',{'pageNum':1,'pageSize':9999})
// }
//获取选择模板列表
export function getTemplateTitle(){
    return get('/yun/hpTemp')
}
//通过id获取背景图主色值和模板
export function getTemplateColorPic(id){
    // return get('/v3/cvts/' + id)
    return get('/api/admin2/cvts/' + id) //冯修改
}
export function getTemplateColorPicMeet(id){
    return get('/api/admin/cvts/' + id)
}
//用户
export function postConvention(data){
    return postKfOrYH('/api/admin/convention',data) //冯修改
}
//客服
export function postConventionKf(data){
    return postKfOrYH('/api/admin/conventionByKf',data) //冯修改
}


//会务------------------

//用户
export function postConventionAffairs(data){
    return postKfOrYH('/conferenceAffairs/convention',data) //冯修改
}
//客服
export function postConventionAffairsKf(data){
    return postKfOrYH('/conferenceAffairs/conventionByKf',data) //冯修改
}





//删除
export function putImgs(id){
    return put('/api/admin/conventionUpdBgImg/'+id)
}

// export function putConvention(id,data){
//     return put('/v3/hometemp/' +id,data)
// }

export function putConvention(id,data){
    return put('/yun/homeTemp/' +id,data)
}
// 修改首页模板
// export function putConvention(id,data){
//     return put('/yun/homeTemp/' +id,data)
// }
//获取已选择功能列表
export function getFuncs(id){
    // return get('/v3/funcs/' +id)
    return get('/api/admin2/funcs/' +id) //冯修改
}
export function postFunc(sout,data){
    // return post('/v3/func' +'?sout=' + sout,data)
    return post('/api/admin2/func' +'?sout=' + sout,data) //冯修改
}
// export function delTemplate(id){
//     return del('/v3/hometemp/' + id)
// }
//删除模板
export function delTemplate(id){
    return del('/yun/homeTemp/' + id)
}
export function getTemplateFile(id){
    // return get('/v3/hometemp/upload/' + id)
    return get('/api/admin2/hometemp/upload/' + id) //冯修改
}
// 新增负责人
export function addAddress(data) {
    return post("/conferenceAffairs/convention/task/member",data);
}